import { AxiosError } from 'axios';
import useToast from './useToast';
import { ErrorType } from '../api/mutator/custom-instance';
import useLocale from '../locale/useLocale';

type ApiErrorType = string;

const useGenericErrorToast = () => {
    const { l } = useLocale();
    const showToast = useToast();
    // eslint-disable-next-line
    return (error: AxiosError<ApiErrorType> | ErrorType<any>) => {
        let errorTitle = error.response
            ? `${l('_error')}: ${error.response?.status.toString()}`
            : `${l('_error')}: ${error.code || l('_unknown')}`;

        // Extract error message - handle ProblemDetails, string, and legacy ErrorResponse formats
        let errorMessage = error.message;
        if (error.response?.data) {
            const data = error.response.data as any;
            if (typeof data === 'string') {
                errorMessage = data;
            } else if (typeof data === 'object' && data !== null) {
                // ProblemDetails format (from GlobalExceptionHandler / model validation)
                if (data.title) {
                    errorTitle = data.title;
                }
                if (data.errors && typeof data.errors === 'object') {
                    // Validation errors dictionary: { field: [messages] }
                    const allErrors = Object.values(
                        data.errors as Record<string, string[]>
                    )
                        .flat()
                        .join(', ');
                    errorMessage = allErrors;
                } else if (data.detail) {
                    errorMessage = data.detail;
                } else if (data.errorMessage) {
                    // Legacy ErrorResponse format
                    errorMessage = data.errorMessage;
                } else {
                    errorMessage = JSON.stringify(data);
                }
            }
        }

        showToast(errorTitle, errorMessage, 'error');
    };
};

export default useGenericErrorToast;
